import React from "react";
import { Row, Col } from "react-bootstrap";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
//import rtOptions from "../../../richText/richTextOptions";
import { WMKLink } from "wmk-lib";

const FooterColumn = ({ column, isMobile }) => {
  const { name } = column;
  return (
    <Row className="flex-column">
      {!isMobile ? (
        <>
          <Col>
            <h6 style={{ fontWeight: 600 }}>{name}</h6>
          </Col>
          <Col>{documentToReactComponents(column.text.json,)}</Col>
        </>
      ) : (
        <Col>
          <WMKLink
            to={column.email ? `mailto:${column.email}` : column.links[0].url}
            target="self"
          >
            <h6 style={{ fontWeight: 600 }}>{name}</h6>
          </WMKLink>
        </Col>
      )}
      {column.email && !isMobile ? (
        <Col>
          <WMKLink mailto>{column.email}</WMKLink>
        </Col>
      ) : null}
      {column.links &&
        !isMobile &&
        column.links.length &&
        column.links.map((link, i) => {
          return (
            <Col key={"footerlink-" + i}>
              <WMKLink to={link.url} target={link.target}>
                Learn more
              </WMKLink>
            </Col>
          );
        })}
    </Row>
  );
};

export default FooterColumn;
